import { db } from "@/firebaseConfig";

const groupOrdersCollection = db.collection("group_orders");

const saveGroupOrder = async data => {
  groupOrdersCollection
    .doc()
    .set(data)
    .then(() => {
      console.log("GroupOrder successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateGroupOrder = async (id, data) => {
  groupOrdersCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("GroupOrder successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteGroupOrder = async id => {
  groupOrdersCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("GroupOrder successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getGroupOrderById = async id => {
  return groupOrdersCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

export {
  groupOrdersCollection,
  saveGroupOrder,
  updateGroupOrder,
  deleteGroupOrder,
  getGroupOrderById
};
